// extracted by mini-css-extract-plugin
export var deleteIcon = "_or-5";
export var deleteOption = "_or-3";
export var divider = "_or-2";
export var downloadIcon = "_or-4";
export var drawer = "_or-0";
export var drawerFooter = "_or-6";
export var drawerOpen = "_or-1";
export var highlighted = "_or-7";
export var lighterHighlight = "_or-8";